import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';

import {PoDynamicFormField, PoLookupColumn, PoLookupFilter, PoLookupFilteredItemsParams} from '@po-ui/ng-components';
import {environment} from 'src/environments/environment';
import { UtilService } from 'src/app/service/util';
import { Zpr, ZprList } from '../interface/zpr';

@Injectable({
  providedIn: 'root'
})
export class ZprLookupService implements PoLookupFilter {
  url = `${environment.urlApiProtheus}/wsrbase/zpr`;
  grupo = '';

  constructor(
    protected httpClient: HttpClient,
    protected utilService: UtilService
  ) {}

  getFilteredItems(filteredParams: PoLookupFilteredItemsParams): Observable<any> {
    const {filterParams, advancedFilters, ...restFilteredItemsParams} = filteredParams;
    const params = {...restFilteredItemsParams, ...filterParams, ...advancedFilters};

    return this.httpClient.get(`${this.url}/${this.grupo}`, {params});
  }

  getObjectByValue(value: string): Observable<Zpr> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.httpClient.get<Zpr>(`${this.url}/${this.grupo}/${value}`,httpOptions);
  }

  getAdvancedFilter(): Array<PoDynamicFormField> {
    return [
      {property: 'CZPRCHAVE' , optional: true, gridColumns: 6, label: 'Chave'},
      {property: 'CZPRGENERI', optional: true, gridColumns: 6, label: 'Descrição'},
    ];
  }

  getColumnsFilter(): Array<PoLookupColumn> {
    return [
      {property: 'CZPRCHAVE' , label: 'Chave'},
      {property: 'CZPRGENERI', label: 'Descrição'},
    ];
  }

  getColumnsFilterCompleto(): Array<PoLookupColumn> {
    return [
      {property: 'CZPRCHAVE' , label: 'Chave'     },
      {property: 'CZPRGENERI', label: 'Descrição' },
      {property: 'CZPRDESC'  , label: 'Informação'},
    ];
  }

  getFieldFormater(value: Zpr): string {
    return `${value.CZPRCHAVE} - ${value.CZPRGENERI}`;
  }

  getZprLista(): Observable<ZprList>{
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.httpClient.get<ZprList>(`${this.url}/${this.grupo}`, httpOptions);
  }

  putZpr(zpr: Zpr): Observable<any>{
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.httpClient.put<any>(`${this.url}`, zpr, httpOptions);
  }
}
